import { render, staticRenderFns } from "./EditCom.vue?vue&type=template&id=61c0a750&scoped=true&"
import script from "./EditCom.vue?vue&type=script&lang=js&"
export * from "./EditCom.vue?vue&type=script&lang=js&"
import style0 from "./EditCom.vue?vue&type=style&index=0&id=61c0a750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0a750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c0a750')) {
      api.createRecord('61c0a750', component.options)
    } else {
      api.reload('61c0a750', component.options)
    }
    module.hot.accept("./EditCom.vue?vue&type=template&id=61c0a750&scoped=true&", function () {
      api.rerender('61c0a750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/EditCom.vue"
export default component.exports